
import React from 'react';
import { ERCButton } from 'components/button';
import { ERCText } from 'components/text';
import avatarImg from 'assets/images/adebayobimpe.svg';
import { useNavigate } from 'react-router-dom';
// import { duration } from '@mui/material';

const CourseCard = ({ thumbnail,title,id, name ,duration, instructor, courseName, handleViewClick, description}) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    handleViewClick(id); 
  };

  return (
    <div className="flex flex-col p-6 gap-2 rounded-lg bg-[#F2F2EE] relative"  >
      <div className="flex flex-col">
        <img src={thumbnail} alt="" className="w-full h-[300px]" />
        <div className="flex p-2 justify-center items-center gap-2 absolute bg-[#FFD600] rounded-md top-[22%] left-[10%]">
          <ERCText weight="700" size="12px">{title}</ERCText>
        </div>
      </div>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col items-end gap-6">
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.99967 1.33325C11.6817 1.33325 14.6663 4.31792 14.6663 7.99992C14.6663 11.6819 11.6817 14.6666 7.99967 14.6666C4.31767 14.6666 1.33301 11.6819 1.33301 7.99992C1.33301 4.31792 4.31767 1.33325 7.99967 1.33325ZM7.99967 2.66659C6.58519 2.66659 5.22863 3.22849 4.22844 4.22868C3.22824 5.22888 2.66634 6.58543 2.66634 7.99992C2.66634 9.41441 3.22824 10.771 4.22844 11.7712C5.22863 12.7713 6.58519 13.3333 7.99967 13.3333C9.41416 13.3333 10.7707 12.7713 11.7709 11.7712C12.7711 10.771 13.333 9.41441 13.333 7.99992C13.333 6.58543 12.7711 5.22888 11.7709 4.22868C10.7707 3.22849 9.41416 2.66659 7.99967 2.66659ZM7.99967 3.99992C8.16296 3.99994 8.32057 4.05989 8.44259 4.1684C8.56461 4.2769 8.64257 4.42642 8.66167 4.58859L8.66634 4.66659V7.72392L10.471 9.52859C10.5906 9.64856 10.66 9.80954 10.6652 9.97884C10.6703 10.1481 10.6109 10.3131 10.4988 10.4401C10.3868 10.5671 10.2306 10.6468 10.062 10.6629C9.89341 10.6789 9.725 10.6302 9.59101 10.5266L9.52834 10.4713L7.52834 8.47125C7.42473 8.36755 7.35818 8.23259 7.33901 8.08725L7.33301 7.99992V4.66659C7.33301 4.48977 7.40325 4.32021 7.52827 4.19518C7.65329 4.07016 7.82286 3.99992 7.99967 3.99992Z" fill="#252525" />
              </svg>
              <ERCText size="12px" color="#252525">{duration}</ERCText>
            </div>
            <div className="flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.99967 11.5133L12.1197 13.9999L11.0263 9.31325L14.6663 6.15992L9.87301 5.75325L7.99967 1.33325L6.12634 5.75325L1.33301 6.15992L4.97301 9.31325L3.87967 13.9999L7.99967 11.5133Z" fill="#FDCA15" />
              </svg>
              <ERCText align="right" weight="700" size="12px">{'4.4(44)'}</ERCText>
            </div>
          </div>
          <div className="flex flex-col items-start gap-4">
            <ERCText size="20px" weight="700" color="#0B7077" lHeight="24px">{name}</ERCText>
            <ERCText align="justify" size="14px" weight="400" lHeight="20px">{description}</ERCText>
          </div>
        </div>

        <div className="flex items-center justify-between w-full h-[38px]">
          <div className="flex items-center gap-2">
            <img src={avatarImg} alt="" className="w-8 h-8" />
            <ERCText size="12px" color="#525252">{instructor}</ERCText>
          </div>
          <div>
          <ERCButton
  height="38px"
  width="110px"
  onClick={() => {
    window.scrollTo(0, 0);
    navigate("/login-student");
    handleCardClick();
  }}
  // onClick={handleCardClick}
>
  Enroll Now
</ERCButton>

          </div>
        </div>
      </div>
    </div>
  );
};





 export default CourseCard;

